import React, { useState, useEffect, useCallback } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Chatbot from './Chatbot'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTerminal } from '../context/TerminalContext'

function Layout({ children, onLogout, userName, factories, navigate }) {
  const { isHmiMode, terminal } = useTerminal()

  const [sidebarVisible, setSidebarVisible] = useState(() => {
    const saved = localStorage.getItem('sidebarVisible')
    return saved !== null ? saved === 'true' : true
  })

  useEffect(() => {
    localStorage.setItem('sidebarVisible', sidebarVisible.toString())
  }, [sidebarVisible])

  const toggleSidebar = useCallback(() => {
    setSidebarVisible(prev => !prev)
  }, [])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
        e.preventDefault()
        toggleSidebar()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [toggleSidebar])

  return (
    <div className="h-screen min-h-0 flex flex-col overflow-hidden bg-gray-900">
      <Header
        onLogout={onLogout}
        userName={userName}
        factories={factories}
        navigate={navigate}
        isHmiMode={isHmiMode}
        terminalName={terminal?.name}
        terminalLine={terminal?.prodLine}
      />

      <div className="flex-1 min-h-0 flex relative">
        <button
          onClick={toggleSidebar}
          className={`absolute top-4 z-50 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-r-lg p-2.5 shadow-lg transition-all duration-300 hover:scale-105 ${
            sidebarVisible ? 'left-64' : 'left-0'
          }`}
          title={sidebarVisible ? 'Ocultar menú (Ctrl+B)' : 'Mostrar menú (Ctrl+B)'}
          aria-label={sidebarVisible ? 'Ocultar menú' : 'Mostrar menú'}
        >
          {sidebarVisible ? (
            <ChevronLeft size={18} className="text-gray-300" />
          ) : (
            <ChevronRight size={18} className="text-gray-300" />
          )}
        </button>

        <div className={`sticky top-0 self-start h-full min-h-0 transition-all duration-300 ease-in-out flex-shrink-0 overflow-hidden ${
          sidebarVisible ? 'w-64' : 'w-0'
        }`}>
          <Sidebar isVisible={sidebarVisible} />
        </div>

        <main className="flex-1 min-h-0 overflow-auto">
          {children}
        </main>
      </div>

      <Chatbot />
    </div>
  )
}

export default Layout
